<dialog-gala (clickClose)="hide()">
    <span gala-dialog-titre>{{titre}}</span>
    <form [formGroup]="formProfil" autocomplete="off">
        <div class="container">
            <div class="row">
                @if (droitsAccess.write) {
                <input-gala formControlName="PROFIL" label="{{lgTrad.NOMPROFIL}}" />
                } @else {
                <input-gala value="{{profilModif.PROFIL}}" label="{{lgTrad.NOMPROFIL}}" [disabled]="true" />
                }
            </div>

            <div class="row">
                <input-gala value="{{profilModif.NOMAPP}}" label="{{lgTrad.APPLICATIF}}" [disabled]="true" />
            </div>

            <div class="row">
                <select-ouinon formControlName="PORTEFEUILLE" [label]="lgTrad.PORTEFEUILLE" />
            </div>

            @if (listeServices?.length > 0) {
            <div class="separator">
                <span>Modules</span>
            </div>
            <div class="row overflow-xxl">
                <ng-container *ngTemplateOutlet="tableauOptions; context: { optionsList: listeServices }" />
            </div>
            }

            @if (listeFonctionnalites?.length > 0) {
            <div class="separator">
                <span>Fonctionnalités</span>
            </div>
            <div class="row overflow-xxl">
                <ng-container *ngTemplateOutlet="tableauOptions; context: { optionsList: listeFonctionnalites }" />
            </div>
            }

        </div>
    </form>

    <div gala-dialog-actions>
        @if (droitsAccess.write) {
        <button mat-stroked-button color="primary" (click)="onSaveProfil()">{{lgTrad.ENR}}</button>
        }
        <button mat-stroked-button color="accent" (click)="hide()">{{lgTrad.RET}}</button>
    </div>
</dialog-gala>

<ng-template #tableauOptions let-optionsList="optionsList">
    <table class="table table-striped tableProfil table-sm mb-0">
        <tbody>
            @for (option of optionsList; track option) {
            <tr>
                @if (option.NIVEAU === 1) {
                <td class="profilOption profilModule">
                    <div class="d-flex  align-items-center">
                        @if (descriptionsMap.get(option.IDOPTION)) {
                        <i class="fa fa-info-circle mr-2" [matTooltip]="descriptionsMap.get(option.IDOPTION)"></i>
                        }
                        <span>{{option.LIBOPTION}}</span>
                    </div>
                </td>
                <td colspan="3" class="text-center profilModule">
                    <div class="btn-group">
                        <gala-btn [color]="option.DROIT === 'C' ? 'success' : 'clair'"
                            (click)="setModuleAccess(option.IDOPTION,'C')" class="mr-0">
                            <i class="fas fa-check"></i>
                        </gala-btn>

                        <gala-btn [color]="option.DROIT === 'V' ? 'alert' : 'clair'"
                            (click)="setModuleAccess(option.IDOPTION,'V')" class="mr-0">
                            <i class="fas fa-eye"></i>
                        </gala-btn>

                        <gala-btn [color]="(option.DROIT !== 'C' && option.DROIT !== 'V') ? 'warn' : 'clair'"
                            (click)="setModuleAccess(option.IDOPTION,'I')" class="mr-0">
                            <i class="fas fa-ban"></i>
                        </gala-btn>
                    </div>
                </td>
                } @else if (option.NIVEAU === 2) {
                <td pt-0 pb-0>
                    <div class="d-flex align-items-center">
                        @if (descriptionsMap.get(option.IDOPTION)) {
                        <i class="fa fa-info-circle" [matTooltip]="descriptionsMap.get(option.IDOPTION)"></i>
                        }
                        <span>
                            <i class="fa fa-arrow-circle-o-right ml-2 mr-1" aria-hidden="true"></i>
                            {{option.LIBOPTION}}
                        </span>
                    </div>
                </td>
                <td class="text-right col-btngroup" pt-0 pb-0>
                    <div class="btn-group">
                        @if (option.DROITPARENT === 'C') {
                        <gala-btn [color]="option.DROIT === 'C' ? 'success' : 'clair'"
                            (click)="setOptionAccess(option.IDOPTION,'C')" class="mr-0">
                            <i class="fas fa-check"></i>
                        </gala-btn>
                        }
                        @if (option.DROITPARENT === 'C' || option.DROITPARENT === 'V') {
                        <gala-btn [color]="option.DROIT === 'V' ? 'alert' : 'clair'"
                            (click)="setOptionAccess(option.IDOPTION,'V')" class="mr-0">
                            <i class="fas fa-eye"></i>
                        </gala-btn>
                        }
                        <gala-btn [color]="(option.DROIT !== 'C' && option.DROIT !== 'V') ? 'warn' : 'clair'"
                            (click)="setOptionAccess(option.IDOPTION,'I')" class="mr-0">
                            <i class="fas fa-ban"></i>
                        </gala-btn>
                    </div>
                </td>
                }
            </tr>
            }
        </tbody>
    </table>
</ng-template>
